import { render, staticRenderFns } from "./spellcheck.vue?vue&type=template&id=d8f73a18&"
import script from "./spellcheck.vue?vue&type=script&lang=ts&"
export * from "./spellcheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports